import { render, staticRenderFns } from "./QuestionListEdit.vue?vue&type=template&id=27765cd5&scoped=true&"
import script from "./QuestionListEdit.vue?vue&type=script&lang=ts&"
export * from "./QuestionListEdit.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionListEdit.vue?vue&type=style&index=0&id=27765cd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27765cd5",
  null
  
)

export default component.exports